import React, { useState } from 'react';
import EmailVerification from '../../components/passwordRecoverySteps/EmailVerification';
import NewPassword from '../../components/passwordRecoverySteps/NewPassword';
import OtpVerification from '../../components/passwordRecoverySteps/OtpVerification';

const Steps = {
    1: EmailVerification,
    2: OtpVerification,
    3: NewPassword
}

const ForgotPassword = () => {
    const [step, setStep] = useState(1);
    const CurrentStep = Steps[step];
    const [values, setValues] = useState({
        email: "",
        userId: "",
        code: ""
    })

    function handleNext() {
        if (step === 3) {
            return;
        } else {
            setStep(step + 1);
        }
    }


    function handleBack() {
        if (step === 1) {
            return;
        } else {
            setStep(step - 1);
        }
    }

    return (
        <>
            <CurrentStep setStepValues={setValues} stepsValues={values} onNext={handleNext} onBack={handleBack} />
        </>
    )
}

export default ForgotPassword